var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.79376 5.34331C2.40208 5.7995 2.40208 6.53498 2.79376 6.99116L9.43645 14.7277C9.7482 15.0908 10.2518 15.0908 10.5635 14.7277L17.2062 6.99116C17.5979 6.53498 17.5979 5.7995 17.2062 5.34331C16.8145 4.88713 16.1831 4.88713 15.7914 5.34331L9.996 12.0837L4.20064 5.334C3.81695 4.88713 3.17746 4.88713 2.79376 5.34331Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.68629350.svg";
export { ForwardRef as ReactComponent };